// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gp-6";
export var emphasizeQuantity = "_gp-3";
export var flatBottomCorners = "_gp-5";
export var productImage = "_gp-0";
export var quantityContainer = "_gp-2";
export var tooltip = "_gp-1";
export var wrapAndEllipsesOverflow = "_gp-4";